export default class PricingToggle {
    constructor () {
        this.elToggle = document.querySelector('[data-pl-pricing]')
        this.prices = document.querySelectorAll('.pricing-table-price')
        this.buttons = document.querySelectorAll('.pricing-table-btn')
        this.currentBilling = 'monthly'

        if (!this.elToggle)
            return

        this.elToggle.addEventListener('click', this.changeCycle.bind(this))
    }

    changeCycle (e) {
        const button = e.target.closest('button')

        if (!button)
            return

        const billing = ((button.dataset || {}).plPricingSwitch || {})

        if (billing !== this.currentBilling) {
            this.currentBilling = billing

            this.elToggle.classList.toggle('pricing-table-switch-on')
            this.updButtons(this.currentBilling)
            this.updPrices(this.currentBilling)
        }
    }

    updButtons (period) {
        if (!this.buttons)
            return

        this.buttons.forEach(button => {
            button.setAttribute('href', button.getAttribute('data-subscribe-' + period))
            button.textContent = button.getAttribute('data-name-' + period)
        })
    }

    updPrices (period) {
        if (!this.prices)
            return

        this.prices.forEach(price => {
            price.classList.toggle('pricing-table-price-annually')
            price.textContent = price.getAttribute('data-price-' + period)
        })
    }
}
